import React from "react";
import {css, Theme} from "@emotion/react";

import {borderRadius} from "@pg-design/helpers-css";
import {IRange} from "@pg-design/inputs-module";

import {ISearchFilter} from "../../types/ISearchFilters";
import {isValueInRange, updateValueBounds} from "../../utils/filters/range_checkbox_filter_data_translations";
import {FiltersSelectRangeSingleElement} from "./FiltersSelectRangeSingleElement";

interface IProps {
    filter: ISearchFilter<string, number>;
    value: IRange<number | "">;
    onChange: (name: string, value: IRange<number | "">) => void;
}

export const FilterSelectRange = (props: IProps) => {
    const onChange = (name: string, value: number) => {
        return props.onChange(name, updateValueBounds(props.value, value, firstOption.value, lastOption.value, allOptionValues));
    };

    const firstOption = props.filter.filterOptions[0];
    const lastOption = props.filter.filterOptions[props.filter.filterOptions.length - 1];
    const allOptionValues = props.filter.filterOptions.map((filterOption) => filterOption.value);

    return (
        <ul css={checkboxList}>
            {props.filter.filterOptions.map((option) => (
                <li key={option.id} css={[checkboxListElement]}>
                    <FiltersSelectRangeSingleElement
                        name={props.filter.id}
                        value={option.value}
                        onChange={onChange}
                        label={<span>{option.label}</span>}
                        isActive={isValueInRange(props.value, option.value, firstOption.value, lastOption.value)}
                        isNonActive={isValueInRange(props.value, option.value, firstOption.value, lastOption.value, -1)}
                        isDisabled={option.isDisabled}
                    />
                </li>
            ))}
        </ul>
    );
};

const checkboxList = css`
    padding: 0;
    margin: 0 0 2.5rem 0;
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.2rem;
    background-color: #fff;
`;

const checkboxListElement = (theme: Theme) => css`
    flex-basis: 300%;

    & > div {
        border-top: 1px solid ${theme.colors.gray[300]};
        border-bottom: 1px solid ${theme.colors.gray[300]};
        border-right: 1px solid ${theme.colors.gray[300]};
    }

    &:first-of-type > div {
        ${borderRadius(1, 0, 0, 1)};
        border-left: 1px solid ${theme.colors.gray[300]};
    }

    &:last-of-type > div {
        ${borderRadius(0, 1, 1, 0)};
        border-right: 1px solid ${theme.colors.gray[300]};
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {borderRadius} from "@pg-design/helpers-css";
import {IRange} from "@pg-design/inputs-module";

import {ISearchFilter} from "../../types/ISearchFilters";
import {isValueInRange, updateValueBounds} from "../../utils/filters/range_checkbox_filter_data_translations";
import {FiltersSelectRangeSingleElement} from "./FiltersSelectRangeSingleElement";

interface IProps {
    filter: ISearchFilter<string, number>;
    value: IRange<number | "">;
    onChange: (name: string, value: IRange<number | "">) => void;
}

export const FilterSelectRange = (props: IProps) => {
    const onChange = (name: string, value: number) => {
        return props.onChange(name, updateValueBounds(props.value, value, firstOption.value, lastOption.value, allOptionValues));
    };

    const firstOption = props.filter.filterOptions[0];
    const lastOption = props.filter.filterOptions[props.filter.filterOptions.length - 1];
    const allOptionValues = props.filter.filterOptions.map((filterOption) => filterOption.value);

    return (
        <ul css={checkboxList}>
            {props.filter.filterOptions.map((option) => (
                <li key={option.id} css={[checkboxListElement]}>
                    <FiltersSelectRangeSingleElement
                        name={props.filter.id}
                        value={option.value}
                        onChange={onChange}
                        label={<span>{option.label}</span>}
                        isActive={isValueInRange(props.value, option.value, firstOption.value, lastOption.value)}
                        isNonActive={isValueInRange(props.value, option.value, firstOption.value, lastOption.value, -1)}
                        isDisabled={option.isDisabled}
                    />
                </li>
            ))}
        </ul>
    );
};

const checkboxList = css`
    padding: 0;
    margin: 0 0 2.5rem 0;
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.2rem;
    background-color: #fff;
`;

const checkboxListElement = (theme: Theme) => css`
    flex-basis: 300%;

    & > div {
        border-top: 1px solid ${theme.colors.gray[300]};
        border-bottom: 1px solid ${theme.colors.gray[300]};
        border-right: 1px solid ${theme.colors.gray[300]};
    }

    &:first-of-type > div {
        ${borderRadius(1, 0, 0, 1)};
        border-left: 1px solid ${theme.colors.gray[300]};
    }

    &:last-of-type > div {
        ${borderRadius(0, 1, 1, 0)};
        border-right: 1px solid ${theme.colors.gray[300]};
    }
`;
